import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
// Component
import Booking from '../../components/Booking';

import s from './Book.css';

const Book = () => {
    return (
        <>
            <Booking />
        </>
    );
}

export default withStyles(s)(Book);